import { Input } from '@builder.io/sdk';

import { buttonFields } from 'molecules/Button/config';
import imageField from 'molecules/Image/config';

import { idField } from 'utils/builder/fields';

const bentoBoxCardFields = [
  idField,
  imageField('cardImage'),
  {
    name: 'title',
    type: 'string',
    defaultValue: 'Default Title',
    helperText: 'Heading text displayed on the card.',
  },
  {
    name: 'description',
    type: 'richText',
    defaultValue: '<p>Default description text</p>',
    helperText: 'Body text displayed under the title. Supports basic formatting.',
  },
  {
    name: 'button',
    type: 'object',
    subFields: buttonFields,
    helperText: 'Optional button for this card. Configure label, link, and style.',
  },
] as const satisfies DeepReadonly<Input[]>;

export type BentoBoxCardConfigProps = GenerateBuilder<typeof bentoBoxCardFields>;

export default bentoBoxCardFields;
